import React from 'react';
import styled from 'styled-components';
import { background } from 'styled-system';
import css from '@styled-system/css';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

const StyledSidenav = styled.div<{ open: boolean }>(
  ({ open }) =>
    // @ts-ignore-start
    css({
      position: `fixed`,
      top: 0,
      left: 0,
      bottom: 0,
      zIndex: 1,
      minWidth: 0,
      width: 256,
      maxHeight: '100vh',
      overflowX: 'visible',
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch',
      transition: 'transform .2s ease-out',
      transform: open ? 'translateX(0)' : 'translate(-100%)',
      bg: 'background'
    }),
  // @ts-ignore-end
  background
);

const Sidenav: React.FC<{ open: boolean; onClick: any }> = ({
  open,
  children,
  ...props
}) => (
  <React.Fragment>
    {open && <Overlay {...props} />}
    <StyledSidenav open={open}>{children}</StyledSidenav>
  </React.Fragment>
);

export default Sidenav;
